module.exports = __webpack_public_path__ + "img/m_banner.e4305d33.png";